var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"do-not-print w-h6 page-title mt-2 mb-8",class:{'info--text text--darken-1': !_vm.no_color},attrs:{"data-test-id":"page-title"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }